module.exports = __webpack_public_path__ + "static/fonts/Fact-BlackItalic.b9e4d9c.woff";